// import React, { useState } from "react";
// import axios from "axios";
// import config from "../../config";

// const baseUrl = config.baseURL;

// // ── Static Plan Data ──────────────────────────────────────────────────────────
// const PLANS = [
//   {
//     id: null,
//     plan_key: "free",
//     name: "Starter",
//     tier: "FREE",
//     isFree: true,
//     isPopular: false,
//     yearlyPrice: 0,
//     monthlyEquiv: 0,
//     users: "1 user",
//     storage: "500 MB",
//     trial: "No credit card required",
//     description:
//       "Get started with core tools and explore Spade ERP at zero cost.",
//     highlights: [
//       "1 user · 500 MB storage",
//       "Basic accounting & invoicing",
//       "100 products · 200 transactions / month",
//       "ETA e-invoicing (Egypt)",
//       "Email support",
//     ],
//   },
//   {
//     id: null,
//     plan_key: "growth",
//     name: "Growth",
//     tier: "BUSINESS",
//     isFree: false,
//     isPopular: true,
//     yearlyPrice: 5000,
//     monthlyEquiv: 416,
//     users: "Up to 10 users",
//     storage: "10 GB",
//     trial: "14-day free trial",
//     description:
//       "Everything a growing business needs — one platform, zero compromises.",
//     highlights: [
//       "Up to 10 users · 10 GB storage",
//       "Full accounting & CRM ",
//       "eCommerce store (Spade subdomain)",
//       "Complete financial reports & dashboards",
//       "Up to 3 branches",
//       "ETA & ZATCA e-invoicing",
//       "WhatsApp + email support",
//     ],
//   },
//   {
//     id: null,
//     plan_key: "pro",
//     name: "Pro",
//     tier: "PROFESSIONAL",
//     isFree: false,
//     isPopular: false,
//     yearlyPrice: 14400,
//     monthlyEquiv: 1200,
//     users: "Up to 30 users",
//     storage: "Unlimited",
//     trial: "14-day free trial",
//     description:
//       "Enterprise-grade power built for mid-market companies that demand full control.",
//     highlights: [
//       "Up to 30 users · Unlimited storage",
//       "Everything in Growth",
//       "Custom domain for eCommerce",
//       "Manufacturing module + Projects",
//       "Unlimited branches + multi-company",
//       "REST API access & webhooks",
//       "24/7 phone & chat support",
//       "Dedicated account manager",
//     ],
//   },
// ];

// const COMPARE_ROWS = [
//   {
//     label: "Annual price",
//     vals: ["Free", "EGP 5,000 / yr", "EGP 14,400 / yr"],
//   },
//   { label: "Users", vals: ["1", "Up to 10", "Up to 30"] },
//   { label: "Storage", vals: ["500 MB", "10 GB", "Unlimited"] },
//   { label: "Branches", vals: ["1", "Up to 3", "Unlimited"] },
//   { label: "Accounting", vals: ["Basic", "Full", "Full"] },
//   { label: "CRM", vals: [false, true, true] },
//   { label: "HR & Payroll", vals: [false, true, true] },
//   { label: "eCommerce", vals: [false, "Subdomain", "Custom domain"] },
//   { label: "Financial reports", vals: [false, true, true] },
//   { label: "Manufacturing", vals: [false, false, true] },
//   { label: "API access", vals: [false, false, true] },
//   { label: "ETA e-invoicing", vals: [true, true, true] },
//   { label: "ZATCA (Saudi)", vals: [false, true, true] },
//   {
//     label: "Support",
//     vals: ["Email", "Email + WhatsApp", "24/7 Phone + Chat"],
//   },
//   { label: "Onboarding", vals: [false, "1 session", "3 sessions"] },
//   { label: "Account manager", vals: [false, false, true] },
// ];

// // ── Field ─────────────────────────────────────────────────────────────────────
// const Field = ({
//   label,
//   name,
//   value,
//   onChange,
//   placeholder,
//   type = "text",
//   textarea,
// }) => (
//   <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//     <label
//       style={{
//         fontSize: 13,
//         fontWeight: 600,
//         color: "#374151",
//         letterSpacing: 0.2,
//       }}
//     >
//       {label}
//     </label>
//     {textarea ? (
//       <textarea
//         name={name}
//         value={value}
//         onChange={onChange}
//         placeholder={placeholder}
//         rows={3}
//         style={{ ...M.input, resize: "vertical", height: 80 }}
//       />
//     ) : (
//       <input
//         type={type}
//         name={name}
//         value={value}
//         onChange={onChange}
//         placeholder={placeholder}
//         style={M.input}
//       />
//     )}
//   </div>
// );

// // ── Subscribe Modal ───────────────────────────────────────────────────────────
// const SubscribeModal = ({ plan, onClose }) => {
//   const [form, setForm] = useState({
//     full_name: "",
//     company_name: "",
//     email: "",
//     phone: "",
//     message: "",
//   });
//   const [status, setStatus] = useState("idle");
//   const [errorMsg, setErrorMsg] = useState("");

//   const handle = (e) =>
//     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

//   const submit = async () => {
//     if (!form.full_name.trim() || !form.email.trim() || !form.phone.trim()) {
//       setErrorMsg("Please fill in your full name, email, and phone number.");
//       return;
//     }
//     setStatus("loading");
//     setErrorMsg("");
//     try {
//       const token = localStorage.getItem("token");
//       await axios.post(
//         `${baseUrl}/api/subscription/request`,
//         {
//           plan_id: plan.id,
//           plan_key: plan.plan_key,
//           plan_name: plan.name,
//           plan_price: plan.yearlyPrice,
//           ...form,
//         },
//         { headers: token ? { Authorization: `Bearer ${token}` } : {} }
//       );
//       setStatus("success");
//     } catch (err) {
//       setErrorMsg(
//         err?.response?.data?.message ||
//           "Something went wrong. Please try again."
//       );
//       setStatus("error");
//     }
//   };

//   return (
//     <div
//       style={M.overlay}
//       onClick={(e) => e.target === e.currentTarget && onClose()}
//     >
//       <div style={M.modal}>
//         {status === "success" ? (
//           <div style={M.successWrap}>
//             <div style={M.successIconWrap}>
//               <svg
//                 width="32"
//                 height="32"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="#16a34a"
//                 strokeWidth="2.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <polyline points="20 6 9 17 4 12" />
//               </svg>
//             </div>
//             <h3 style={M.successTitle}>Request Received</h3>
//             <p style={M.successText}>
//               Your request for <strong>{plan.name}</strong> has been submitted.
//               A confirmation was sent to <strong>{form.email}</strong>.
//             </p>
//             <div style={M.payBox}>
//               <div style={M.payTitle}>Bank Transfer Details</div>
//               <div style={M.payGrid}>
//                 {[
//                   ["Bank", "Bank Misr"],
//                   ["Account Holder", "Spade ERP Egypt"],
//                   ["Account No.", "1234567890123456"],
//                   ["Amount", `EGP ${plan.yearlyPrice.toLocaleString()}`],
//                 ].map(([k, v]) => (
//                   <React.Fragment key={k}>
//                     <span style={M.payKey}>{k}</span>
//                     <span style={M.payVal}>{v}</span>
//                   </React.Fragment>
//                 ))}
//               </div>
//               <div style={M.payNote}>
//                 Include your email address in the transfer reference so we can
//                 match your payment.
//               </div>
//             </div>
//             <p
//               style={{
//                 fontSize: 13,
//                 color: "#6b7280",
//                 textAlign: "center",
//                 lineHeight: 1.6,
//               }}
//             >
//               Your plan will be activated within{" "}
//               <strong>1–2 business days</strong> after payment confirmation.
//             </p>
//             <button onClick={onClose} style={M.doneBtn}>
//               Close
//             </button>
//           </div>
//         ) : (
//           <>
//             <div style={M.modalHeader}>
//               <div>
//                 <div style={M.modalTier}>{plan.tier}</div>
//                 <div style={M.modalPlanName}>Spade {plan.name}</div>
//                 <div style={M.modalPrice}>
//                   EGP {plan.yearlyPrice.toLocaleString()}
//                   <span style={M.modalPriceSub}>
//                     {" "}
//                     / year &nbsp;·&nbsp; ≈ EGP {plan.monthlyEquiv} / month
//                   </span>
//                 </div>
//               </div>
//               <button onClick={onClose} style={M.closeBtn} aria-label="Close">
//                 <svg
//                   width="18"
//                   height="18"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2.5"
//                   strokeLinecap="round"
//                 >
//                   <line x1="18" y1="6" x2="6" y2="18" />
//                   <line x1="6" y1="6" x2="18" y2="18" />
//                 </svg>
//               </button>
//             </div>

//             <div style={M.divider} />

//             <p style={M.formHint}>
//               Fill in your details below. After submitting, we'll send you bank
//               transfer instructions and activate your plan once payment is
//               confirmed.
//             </p>

//             <div style={M.fields}>
//               <Field
//                 label="Full Name *"
//                 name="full_name"
//                 value={form.full_name}
//                 onChange={handle}
//                 placeholder="Ahmed Mohamed"
//               />
//               <div
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "1fr 1fr",
//                   gap: 14,
//                 }}
//               >
//                 <Field
//                   label="Email Address *"
//                   name="email"
//                   value={form.email}
//                   onChange={handle}
//                   placeholder="you@company.com"
//                   type="email"
//                 />
//                 <Field
//                   label="Phone Number *"
//                   name="phone"
//                   value={form.phone}
//                   onChange={handle}
//                   placeholder="+20 10 xxxx xxxx"
//                   type="tel"
//                 />
//               </div>
//               <Field
//                 label="Company Name"
//                 name="company_name"
//                 value={form.company_name}
//                 onChange={handle}
//                 placeholder="Your company (optional)"
//               />
//               <Field
//                 label="Notes"
//                 name="message"
//                 value={form.message}
//                 onChange={handle}
//                 placeholder="Any questions or requirements?"
//                 textarea
//               />
//             </div>

//             {errorMsg && <div style={M.errBox}>{errorMsg}</div>}

//             <button
//               onClick={submit}
//               disabled={status === "loading"}
//               style={{
//                 ...M.submitBtn,
//                 opacity: status === "loading" ? 0.65 : 1,
//               }}
//             >
//               {status === "loading"
//                 ? "Submitting…"
//                 : "Submit Subscription Request"}
//             </button>
//             <p style={M.disclaimer}>
//               No online payment required. We'll send bank transfer details by
//               email.
//             </p>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// // ── Plan Card ─────────────────────────────────────────────────────────────────
// const ACCENTS = {
//   free: {
//     border: "#e2e8f0",
//     tierBg: "#f1f5f9",
//     tierColor: "#475569",
//     btnBg: "#f8fafc",
//     btnColor: "#1e293b",
//     btnBorder: "#cbd5e1",
//     check: "#64748b",
//   },
//   growth: {
//     border: "#2E4053",
//     tierBg: "#1e3a5f",
//     tierColor: "#93c5fd",
//     btnBg: "#2E4053",
//     btnColor: "#fff",
//     btnBorder: "#2E4053",
//     check: "#2E4053",
//   },
//   pro: {
//     border: "#7C3AED",
//     tierBg: "#4c1d95",
//     tierColor: "#c4b5fd",
//     btnBg: "#7C3AED",
//     btnColor: "#fff",
//     btnBorder: "#7C3AED",
//     check: "#7C3AED",
//   },
// };

// const CheckSVG = ({ color }) => (
//   <svg
//     width="15"
//     height="15"
//     viewBox="0 0 15 15"
//     fill="none"
//     style={{ flexShrink: 0, marginTop: 1 }}
//   >
//     <circle cx="7.5" cy="7.5" r="7.5" fill={color} fillOpacity="0.12" />
//     <path
//       d="M4.5 7.5l2 2.2L10.5 5"
//       stroke={color}
//       strokeWidth="1.6"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const PlanCard = ({ plan, onSelect }) => {
//   const a = ACCENTS[plan.plan_key];
//   return (
//     <div
//       style={{
//         ...C.card,
//         borderColor: plan.isPopular ? "#2E4053" : "#e8ecf0",
//         borderWidth: plan.isPopular ? 2 : 1,
//         boxShadow: plan.isPopular
//           ? "0 20px 60px rgba(46,64,83,.18), 0 4px 16px rgba(46,64,83,.08)"
//           : "0 2px 8px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04)",
//       }}
//     >
//       {/* Popular ribbon */}
//       {plan.isPopular && (
//         <div style={C.ribbon}>
//           <span style={C.ribbonText}>MOST POPULAR</span>
//         </div>
//       )}

//       {/* Top section */}
//       <div style={{ ...C.top, paddingTop: plan.isPopular ? 36 : 28 }}>
//         <span
//           style={{ ...C.tierBadge, background: a.tierBg, color: a.tierColor }}
//         >
//           {plan.tier}
//         </span>
//         <h2 style={C.planName}>Spade {plan.name}</h2>
//         <p style={C.planDesc}>{plan.description}</p>
//       </div>

//       {/* Price */}
//       <div style={C.priceSection}>
//         {plan.isFree ? (
//           <div style={C.priceRow}>
//             <span style={{ ...C.bigPrice, color: "#16a34a" }}>Free</span>
//             <span style={C.priceSub}>forever</span>
//           </div>
//         ) : (
//           <>
//             <div style={C.priceRow}>
//               <span style={C.currency}>EGP</span>
//               <span style={C.bigPrice}>
//                 {plan.yearlyPrice.toLocaleString()}
//               </span>
//               <span style={C.priceSub}>/yr</span>
//             </div>
//             <div style={C.priceMonthly}>
//               ≈ EGP {plan.monthlyEquiv} / month · billed annually
//             </div>
//           </>
//         )}
//       </div>

//       <div style={C.divider} />

//       {/* Meta chips */}
//       <div style={C.metaRow}>
//         <span style={C.metaChip}>👥 {plan.users}</span>
//         <span style={C.metaChip}>💾 {plan.storage}</span>
//         <span style={C.metaChip}>🎁 {plan.trial}</span>
//       </div>

//       <div style={C.divider} />

//       {/* Highlights */}
//       <ul style={C.featureList}>
//         {plan.highlights.map((h) => (
//           <li key={h} style={C.featureItem}>
//             <CheckSVG color={a.check} />
//             <span style={{ fontSize: 13.5, color: "#374151", lineHeight: 1.5 }}>
//               {h}
//             </span>
//           </li>
//         ))}
//       </ul>

//       {/* CTA */}
//       <button
//         onClick={() => !plan.isFree && onSelect(plan)}
//         style={{
//           ...C.btn,
//           background: a.btnBg,
//           color: a.btnColor,
//           border: `1.5px solid ${a.btnBorder}`,
//           cursor: plan.isFree ? "default" : "pointer",
//           marginTop: 20,
//         }}
//       >
//         {plan.isFree ? "Get Started Free" : "Subscribe Now →"}
//       </button>
//     </div>
//   );
// };

// // ── Comparison Table ──────────────────────────────────────────────────────────
// const CmpVal = ({ v }) => {
//   if (v === true)
//     return (
//       <span style={{ color: "#16a34a", fontWeight: 700, fontSize: 16 }}>✓</span>
//     );
//   if (v === false)
//     return <span style={{ color: "#d1d5db", fontSize: 14 }}>—</span>;
//   return (
//     <span style={{ fontSize: 13, color: "#374151", fontWeight: 500 }}>{v}</span>
//   );
// };

// const CompareTable = () => (
//   <div style={{ overflowX: "auto" }}>
//     <table style={T.table}>
//       <thead>
//         <tr>
//           <th
//             style={{
//               ...T.th,
//               textAlign: "left",
//               background: "#f8fafc",
//               color: "#6b7280",
//               width: 200,
//             }}
//           >
//             Feature
//           </th>
//           <th style={{ ...T.th, background: "#f8fafc", color: "#374151" }}>
//             Starter
//           </th>
//           <th style={{ ...T.th, background: "#2E4053", color: "#fff" }}>
//             Growth
//           </th>
//           <th style={{ ...T.th, background: "#7C3AED", color: "#fff" }}>Pro</th>
//         </tr>
//       </thead>
//       <tbody>
//         {COMPARE_ROWS.map((row, i) => (
//           <tr
//             key={row.label}
//             style={{ background: i % 2 === 0 ? "#fff" : "#f8fafc" }}
//           >
//             <td
//               style={{
//                 ...T.td,
//                 textAlign: "left",
//                 fontWeight: 500,
//                 color: "#374151",
//               }}
//             >
//               {row.label}
//             </td>
//             {row.vals.map((v, j) => (
//               <td
//                 key={j}
//                 style={{
//                   ...T.td,
//                   ...(j === 1
//                     ? { background: "rgba(46,64,83,.03)" }
//                     : j === 2
//                     ? { background: "rgba(124,58,237,.03)" }
//                     : {}),
//                 }}
//               >
//                 <CmpVal v={v} />
//               </td>
//             ))}
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// // ── Main Page ─────────────────────────────────────────────────────────────────
// // currentPageData prop accepted from SiteNavbar but not used (all data is static)
// const PricingPage = ({ currentPageData }) => {
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [showTable, setShowTable] = useState(false);

//   return (
//     <div style={P.page}>
//       {/* ── Hero ── */}
//       <div style={P.hero}>
//         <div style={P.heroInner}>
//           <div style={P.eyebrow}>
//             <span style={P.eyebrowDot} />
//             PRICING & PLANS
//           </div>
//           <h1 style={P.heroTitle}>
//             Transparent Pricing.
//             <br />
//             <span style={{ color: "#93c5fd" }}>No Surprises.</span>
//           </h1>
//           <p style={P.heroSub}>
//             One flat annual fee per plan. No per-user charges. No hidden costs.
//             Bank transfer — your team gets access within 24 hours of payment
//             confirmation.
//           </p>
//           <div style={P.heroBadges}>
//             {[
//               "ETA e-invoicing included",
//               "14-day free trial",
//               "Arabic support 24/7",
//               "Cancel anytime",
//             ].map((t) => (
//               <div key={t} style={P.heroBadge}>
//                 <svg
//                   width="14"
//                   height="14"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="#93c5fd"
//                   strokeWidth="2.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   style={{ flexShrink: 0 }}
//                 >
//                   <polyline points="20 6 9 17 4 12" />
//                 </svg>
//                 <span>{t}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div style={P.heroDecor} />
//       </div>

//       {/* ── Cards ── */}
//       <div style={P.cardsSection}>
//         <div style={P.cardsGrid}>
//           {PLANS.map((p) => (
//             <PlanCard key={p.plan_key} plan={p} onSelect={setSelectedPlan} />
//           ))}
//         </div>
//       </div>

//       {/* ── Comparison table toggle ── */}
//       <div style={P.section}>
//         <div style={P.sectionHead}>
//           <h2 style={P.sectionTitle}>Compare Plans in Detail</h2>
//           <p style={P.sectionSub}>
//             See a full side-by-side breakdown of every feature across all plans.
//           </p>
//           <button onClick={() => setShowTable((v) => !v)} style={P.toggleBtn}>
//             {showTable ? "Hide comparison ▲" : "Show full comparison ▼"}
//           </button>
//         </div>
//         {showTable && <CompareTable />}
//       </div>

//       {/* ── How it works ── */}
//       <div style={P.howSection}>
//         <div style={P.sectionHead}>
//           <h2 style={P.sectionTitle}>How to Get Started</h2>
//           <p style={P.sectionSub}>
//             From signup to full activation in under 2 business days.
//           </p>
//         </div>
//         <div style={P.stepsGrid}>
//           {[
//             {
//               n: "01",
//               icon: "🎯",
//               title: "Choose a plan",
//               desc: "Select the plan that fits your team size and business needs.",
//             },
//             {
//               n: "02",
//               icon: "📋",
//               title: "Submit your details",
//               desc: "Fill in your name, company, and contact info. Takes 60 seconds.",
//             },
//             {
//               n: "03",
//               icon: "🏦",
//               title: "Bank transfer",
//               desc: "We'll email you our bank account details. Transfer the annual fee.",
//             },
//             {
//               n: "04",
//               icon: "🚀",
//               title: "Instant activation",
//               desc: "Once we confirm your payment, your plan is live within 1–2 business days.",
//             },
//           ].map((s, i) => (
//             <div key={s.n} style={P.stepCard}>
//               <div style={P.stepTop}>
//                 <span style={P.stepNum}>{s.n}</span>
//                 <span style={P.stepIcon}>{s.icon}</span>
//               </div>
//               <h3 style={P.stepTitle}>{s.title}</h3>
//               <p style={P.stepDesc}>{s.desc}</p>
//               {i < 3 && <div style={P.stepArrow}>→</div>}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* ── Trust bar ── */}
//       <div style={P.trustBar}>
//         {[
//           ["🔒", "Secure payments", "Bank-grade security"],
//           ["🇪🇬", "ETA compliant", "Phase 1 & 2 certified"],
//           ["📞", "Arabic support", "Dedicated team"],
//           ["💸", "Money-back guarantee", "14 days, no questions"],
//           ["⚡", "Fast onboarding", "Live in 48 hours"],
//         ].map(([icon, title, sub]) => (
//           <div key={title} style={P.trustItem}>
//             <span style={P.trustIcon}>{icon}</span>
//             <div>
//               <div style={P.trustTitle}>{title}</div>
//               <div style={P.trustSub}>{sub}</div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {selectedPlan && (
//         <SubscribeModal
//           plan={selectedPlan}
//           onClose={() => setSelectedPlan(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default PricingPage;

// // ── Page Styles ───────────────────────────────────────────────────────────────
// const P = {
//   page: {
//     backgroundColor: "#f8fafc",
//     minHeight: "100vh",
//     fontFamily:
//       "'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
//   },

//   // hero
//   hero: {
//     background: "linear-gradient(135deg,#0f172a 0%,#1e3a5f 60%,#1e1b4b 100%)",
//     position: "relative",
//     overflow: "hidden",
//     padding: "72px 24px 80px",
//   },
//   heroInner: {
//     maxWidth: 760,
//     margin: "0 auto",
//     position: "relative",
//     zIndex: 1,
//     textAlign: "center",
//   },
//   heroDecor: {
//     position: "absolute",
//     top: -120,
//     right: -120,
//     width: 480,
//     height: 480,
//     borderRadius: "50%",
//     background:
//       "radial-gradient(circle,rgba(124,58,237,.18) 0%,transparent 70%)",
//     pointerEvents: "none",
//   },
//   eyebrow: {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: 8,
//     fontSize: 11,
//     fontWeight: 700,
//     letterSpacing: 3,
//     color: "#93c5fd",
//     marginBottom: 20,
//     textTransform: "uppercase",
//   },
//   eyebrowDot: {
//     width: 6,
//     height: 6,
//     borderRadius: "50%",
//     background: "#60a5fa",
//     display: "inline-block",
//   },
//   heroTitle: {
//     fontSize: "clamp(32px,5vw,52px)",
//     fontWeight: 800,
//     color: "#f1f5f9",
//     lineHeight: 1.12,
//     margin: "0 0 20px",
//     letterSpacing: -1,
//   },
//   heroSub: {
//     fontSize: 17,
//     color: "#94a3b8",
//     lineHeight: 1.75,
//     maxWidth: 600,
//     margin: "0 auto 32px",
//   },
//   heroBadges: {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     gap: "10px 20px",
//   },
//   heroBadge: {
//     display: "flex",
//     alignItems: "center",
//     gap: 7,
//     fontSize: 13.5,
//     color: "#cbd5e1",
//     fontWeight: 500,
//   },

//   // cards
//   cardsSection: { padding: "64px 24px 48px", background: "#f8fafc" },
//   cardsGrid: {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     gap: 28,
//     maxWidth: 1160,
//     margin: "0 auto",
//   },

//   // sections
//   section: { maxWidth: 1000, margin: "0 auto", padding: "48px 24px" },
//   sectionHead: { textAlign: "center", marginBottom: 36 },
//   sectionTitle: {
//     fontSize: 28,
//     fontWeight: 800,
//     color: "#0f172a",
//     margin: "0 0 10px",
//     letterSpacing: -0.5,
//   },
//   sectionSub: {
//     fontSize: 15,
//     color: "#64748b",
//     margin: "0 0 20px",
//     lineHeight: 1.6,
//   },
//   toggleBtn: {
//     background: "none",
//     border: "1.5px solid #e2e8f0",
//     borderRadius: 8,
//     padding: "9px 22px",
//     fontSize: 14,
//     fontWeight: 600,
//     cursor: "pointer",
//     color: "#374151",
//   },

//   // how it works
//   howSection: {
//     background: "#fff",
//     padding: "64px 24px",
//     borderTop: "1px solid #e2e8f0",
//     borderBottom: "1px solid #e2e8f0",
//   },
//   stepsGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
//     gap: 2,
//     maxWidth: 1100,
//     margin: "0 auto",
//     position: "relative",
//   },
//   stepCard: {
//     background: "#f8fafc",
//     borderRadius: 14,
//     padding: "28px 24px 24px",
//     position: "relative",
//     border: "1px solid #e8ecf0",
//   },
//   stepTop: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "flex-start",
//     marginBottom: 14,
//   },
//   stepNum: {
//     fontSize: 11,
//     fontWeight: 800,
//     color: "#2E4053",
//     letterSpacing: 2,
//     background: "#e0e7ff",
//     padding: "4px 10px",
//     borderRadius: 6,
//   },
//   stepIcon: { fontSize: 26 },
//   stepTitle: {
//     fontSize: 16,
//     fontWeight: 700,
//     color: "#0f172a",
//     margin: "0 0 8px",
//   },
//   stepDesc: { fontSize: 13.5, color: "#64748b", lineHeight: 1.6, margin: 0 },
//   stepArrow: {
//     position: "absolute",
//     right: -14,
//     top: "50%",
//     transform: "translateY(-50%)",
//     fontSize: 20,
//     color: "#cbd5e1",
//     zIndex: 2,
//     display: "none",
//   },

//   // trust bar
//   trustBar: {
//     background: "#0f172a",
//     padding: "32px 24px",
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     gap: "24px 48px",
//   },
//   trustItem: { display: "flex", alignItems: "center", gap: 12 },
//   trustIcon: { fontSize: 24 },
//   trustTitle: { fontSize: 13, fontWeight: 700, color: "#f1f5f9" },
//   trustSub: { fontSize: 12, color: "#64748b", marginTop: 1 },
// };

// // ── Card Styles ───────────────────────────────────────────────────────────────
// const C = {
//   card: {
//     width: 340,
//     background: "#fff",
//     borderRadius: 20,
//     display: "flex",
//     flexDirection: "column",
//     position: "relative",
//     overflow: "hidden",
//     borderStyle: "solid",
//     transition: "transform .2s",
//   },
//   ribbon: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     background: "linear-gradient(90deg,#2E4053,#1e3a5f)",
//     padding: "7px 0",
//     textAlign: "center",
//   },
//   ribbonText: {
//     fontSize: 10,
//     fontWeight: 800,
//     color: "#93c5fd",
//     letterSpacing: 3,
//   },
//   top: { padding: "0 28px 20px" },
//   tierBadge: {
//     display: "inline-block",
//     fontSize: 10,
//     fontWeight: 800,
//     letterSpacing: 2,
//     padding: "4px 12px",
//     borderRadius: 20,
//     marginBottom: 14,
//   },
//   planName: {
//     fontSize: 24,
//     fontWeight: 800,
//     color: "#0f172a",
//     margin: "0 0 8px",
//     letterSpacing: -0.5,
//   },
//   planDesc: { fontSize: 13.5, color: "#64748b", lineHeight: 1.6, margin: 0 },
//   priceSection: {
//     padding: "20px 28px",
//     background: "#f8fafc",
//     borderTop: "1px solid #f1f5f9",
//     borderBottom: "1px solid #f1f5f9",
//   },
//   priceRow: {
//     display: "flex",
//     alignItems: "flex-end",
//     gap: 4,
//     marginBottom: 4,
//   },
//   currency: {
//     fontSize: 17,
//     fontWeight: 700,
//     color: "#374151",
//     lineHeight: 2.6,
//   },
//   bigPrice: {
//     fontSize: 48,
//     fontWeight: 800,
//     color: "#0f172a",
//     lineHeight: 1,
//     letterSpacing: -2,
//   },
//   priceSub: { fontSize: 14, color: "#94a3b8", lineHeight: 2.6, marginLeft: 4 },
//   priceMonthly: { fontSize: 12, color: "#94a3b8" },
//   divider: { height: 1, background: "#f1f5f9", margin: "0 28px" },
//   metaRow: {
//     display: "flex",
//     flexDirection: "column",
//     gap: 6,
//     padding: "18px 28px",
//   },
//   metaChip: {
//     fontSize: 13,
//     color: "#374151",
//     display: "flex",
//     alignItems: "center",
//     gap: 6,
//   },
//   featureList: {
//     listStyle: "none",
//     padding: "4px 28px 0",
//     margin: 0,
//     display: "flex",
//     flexDirection: "column",
//     gap: 9,
//   },
//   featureItem: { display: "flex", alignItems: "flex-start", gap: 9 },
//   btn: {
//     margin: "0 28px 28px",
//     padding: "14px",
//     borderRadius: 10,
//     fontSize: 15,
//     fontWeight: 700,
//     textAlign: "center",
//     transition: "opacity .15s, transform .1s",
//   },
// };

// // ── Table Styles ──────────────────────────────────────────────────────────────
// const T = {
//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//     fontSize: 13.5,
//     borderRadius: 12,
//     overflow: "hidden",
//     boxShadow: "0 1px 3px rgba(0,0,0,.08)",
//     minWidth: 640,
//   },
//   th: {
//     padding: "14px 18px",
//     textAlign: "center",
//     fontWeight: 700,
//     fontSize: 13,
//     border: "1px solid #e8ecf0",
//   },
//   td: {
//     padding: "12px 18px",
//     textAlign: "center",
//     border: "1px solid #f1f5f9",
//   },
// };

// // ── Modal Styles ──────────────────────────────────────────────────────────────
// const M = {
//   overlay: {
//     position: "fixed",
//     inset: 0,
//     background: "rgba(15,23,42,.6)",
//     backdropFilter: "blur(4px)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 9999,
//     padding: 16,
//   },
//   modal: {
//     background: "#fff",
//     borderRadius: 20,
//     width: "100%",
//     maxWidth: 520,
//     maxHeight: "92vh",
//     overflowY: "auto",
//     padding: "32px 32px 28px",
//     boxShadow: "0 24px 64px rgba(0,0,0,.2)",
//   },
//   modalHeader: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "flex-start",
//     marginBottom: 20,
//   },
//   modalTier: {
//     fontSize: 10,
//     fontWeight: 800,
//     letterSpacing: 3,
//     color: "#2E4053",
//     marginBottom: 4,
//   },
//   modalPlanName: {
//     fontSize: 24,
//     fontWeight: 800,
//     color: "#0f172a",
//     letterSpacing: -0.5,
//     marginBottom: 6,
//   },
//   modalPrice: { fontSize: 20, fontWeight: 800, color: "#0f172a" },
//   modalPriceSub: { fontSize: 13, fontWeight: 400, color: "#94a3b8" },
//   closeBtn: {
//     background: "none",
//     border: "1px solid #e2e8f0",
//     borderRadius: 8,
//     width: 36,
//     height: 36,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     cursor: "pointer",
//     color: "#64748b",
//     flexShrink: 0,
//   },
//   divider: { height: 1, background: "#f1f5f9", margin: "20px 0" },
//   formHint: {
//     fontSize: 13.5,
//     color: "#64748b",
//     lineHeight: 1.65,
//     margin: "0 0 22px",
//     padding: "12px 16px",
//     background: "#f8fafc",
//     borderRadius: 10,
//     border: "1px solid #e2e8f0",
//   },
//   fields: {
//     display: "flex",
//     flexDirection: "column",
//     gap: 16,
//     marginBottom: 20,
//   },
//   input: {
//     padding: "11px 14px",
//     border: "1.5px solid #e2e8f0",
//     borderRadius: 9,
//     fontSize: 14,
//     color: "#0f172a",
//     outline: "none",
//     fontFamily: "inherit",
//     width: "100%",
//     boxSizing: "border-box",
//     background: "#fff",
//   },
//   errBox: {
//     background: "#fef2f2",
//     border: "1px solid #fecaca",
//     borderRadius: 8,
//     padding: "10px 14px",
//     fontSize: 13,
//     color: "#dc2626",
//     marginBottom: 14,
//   },
//   submitBtn: {
//     width: "100%",
//     padding: "14px",
//     background: "#2E4053",
//     color: "#fff",
//     border: "none",
//     borderRadius: 10,
//     fontSize: 15,
//     fontWeight: 700,
//     cursor: "pointer",
//     letterSpacing: 0.2,
//   },
//   disclaimer: {
//     fontSize: 12,
//     color: "#94a3b8",
//     textAlign: "center",
//     marginTop: 12,
//     lineHeight: 1.6,
//   },
//   successWrap: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     textAlign: "center",
//     gap: 14,
//     padding: "8px 0",
//   },
//   successIconWrap: {
//     width: 64,
//     height: 64,
//     borderRadius: "50%",
//     background: "#f0fdf4",
//     border: "2px solid #86efac",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   successTitle: {
//     fontSize: 24,
//     fontWeight: 800,
//     color: "#0f172a",
//     margin: 0,
//     letterSpacing: -0.5,
//   },
//   successText: {
//     fontSize: 14,
//     color: "#374151",
//     lineHeight: 1.65,
//     margin: 0,
//     maxWidth: 380,
//   },
//   payBox: {
//     background: "#f8fafc",
//     border: "1px solid #e2e8f0",
//     borderRadius: 12,
//     padding: "18px 20px",
//     width: "100%",
//     textAlign: "left",
//   },
//   payTitle: {
//     fontSize: 13,
//     fontWeight: 700,
//     color: "#0f172a",
//     marginBottom: 12,
//   },
//   payGrid: {
//     display: "grid",
//     gridTemplateColumns: "130px 1fr",
//     gap: "8px 12px",
//     fontSize: 13,
//   },
//   payKey: { color: "#64748b" },
//   payVal: { color: "#0f172a", fontWeight: 600 },
//   payNote: {
//     marginTop: 14,
//     fontSize: 12,
//     color: "#92400e",
//     background: "#fef3c7",
//     padding: "9px 12px",
//     borderRadius: 7,
//     lineHeight: 1.55,
//   },
//   doneBtn: {
//     background: "#2E4053",
//     color: "#fff",
//     border: "none",
//     borderRadius: 10,
//     padding: "13px 36px",
//     fontSize: 15,
//     fontWeight: 700,
//     cursor: "pointer",
//   },
// };
import React, { useState } from "react";
import axios from "axios";
import config from "../../config";

const baseUrl = config.baseURL;

// ── Static Plan Data ──────────────────────────────────────────────────────────
const PLANS = [
  {
    id: null,
    plan_key: "free",
    name: "Starter",
    tier: "FREE",
    isFree: true,
    isPopular: false,
    yearlyPrice: 0,
    monthlyEquiv: 0,
    users: "1 user",
    storage: "500 MB",
    trial: "No credit card required",
    description:
      "Get started with core tools and explore Spade ERP at zero cost.",
    highlights: [
      "1 user · 500 MB storage",
      "Basic accounting & invoicing",
      "100 products · 200 transactions / month",
      // "ETA e-invoicing (Egypt)",
      "Email support",
    ],
  },
  {
    id: null,
    plan_key: "growth",
    name: "Growth",
    tier: "BUSINESS",
    isFree: false,
    isPopular: true,
    yearlyPrice: 5000,
    monthlyEquiv: 416,
    users: "Up to 10 users",
    storage: "10 GB",
    trial: "14-day free trial",
    description:
      "Everything a growing business needs — one platform, zero compromises.",
    highlights: [
      "Up to 10 users · 10 GB storage",
      "Full accounting, CRM, HR & payroll",
      "eCommerce store (Spade subdomain)",
      "Complete financial reports & dashboards",
      "Up to 3 branches",
      // "ETA & ZATCA e-invoicing",
      "WhatsApp + email support",
    ],
  },
  {
    id: null,
    plan_key: "pro",
    name: "Pro",
    tier: "PROFESSIONAL",
    isFree: false,
    isPopular: false,
    yearlyPrice: 14400,
    monthlyEquiv: 1200,
    users: "Up to 30 users",
    storage: "Unlimited",
    trial: "14-day free trial",
    description:
      "Enterprise-grade power built for mid-market companies that demand full control.",
    highlights: [
      "Up to 30 users · Unlimited storage",
      "Everything in Growth",
      "Custom domain for eCommerce",
      "Manufacturing module + Projects",
      "Unlimited branches + multi-company",
      "REST API access & webhooks",
      "24/7 phone & chat support",
      "Dedicated account manager",
    ],
  },
];

const COMPARE_ROWS = [
  {
    label: "Annual price",
    vals: ["Free", "EGP 5,000 / yr", "EGP 14,400 / yr"],
  },
  { label: "Users", vals: ["1", "Up to 10", "Up to 30"] },
  { label: "Storage", vals: ["500 MB", "10 GB", "Unlimited"] },
  { label: "Branches", vals: ["1", "Up to 3", "Unlimited"] },
  { label: "Accounting", vals: ["Basic", "Full", "Full"] },
  { label: "CRM", vals: [false, true, true] },
  { label: "HR & Payroll", vals: [false, true, true] },
  { label: "eCommerce", vals: [false, "Subdomain", "Custom domain"] },
  { label: "Financial reports", vals: [false, true, true] },
  { label: "Manufacturing", vals: [true, true, true] },
  { label: "API access", vals: [false, false, true] },
  // { label: "ETA e-invoicing", vals: [true, true, true] },
  // { label: "ZATCA (Saudi)", vals: [false, true, true] },
  {
    label: "Support",
    vals: ["Email", "Email + WhatsApp", "24/7 Phone + Chat"],
  },
  { label: "Onboarding", vals: [false, "1 session", "3 sessions"] },
  { label: "Account manager", vals: [false, false, true] },
];

// ── Field ─────────────────────────────────────────────────────────────────────
const Field = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  type = "text",
  textarea,
}) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
    <label
      style={{
        fontSize: 13,
        fontWeight: 600,
        color: "#374151",
        letterSpacing: 0.2,
      }}
    >
      {label}
    </label>
    {textarea ? (
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={3}
        style={{ ...M.input, resize: "vertical", height: 80 }}
      />
    ) : (
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={M.input}
      />
    )}
  </div>
);

// ── Subscribe Modal ───────────────────────────────────────────────────────────
const SubscribeModal = ({ plan, onClose }) => {
  const [form, setForm] = useState({
    full_name: "",
    company_name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handle = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async () => {
    if (!form.full_name.trim() || !form.email.trim() || !form.phone.trim()) {
      setErrorMsg("Please fill in your full name, email, and phone number.");
      return;
    }
    setStatus("loading");
    setErrorMsg("");
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${baseUrl}/api/subscription/request`,
        {
          plan_id: plan.id,
          plan_key: plan.plan_key,
          plan_name: plan.name,
          plan_price: plan.yearlyPrice,
          ...form,
        },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      setStatus("success");
    } catch (err) {
      setErrorMsg(
        err?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
      setStatus("error");
    }
  };

  return (
    <div
      style={M.overlay}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div style={M.modal}>
        {status === "success" ? (
          <div style={M.successWrap}>
            <div style={M.successIconWrap}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#16a34a"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <h3 style={M.successTitle}>Request Received</h3>
            <p style={M.successText}>
              Your request for <strong>{plan.name}</strong> has been submitted.
              A confirmation was sent to <strong>{form.email}</strong>.
            </p>
            <div style={M.payBox}>
              <div style={M.payTitle}>📲 What happens next?</div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 12 }}
              >
                {[
                  [
                    "1",
                    "We'll call or WhatsApp you",
                    "Our team will contact you on the phone number you provided within a few hours.",
                  ],
                  [
                    "2",
                    "We send you our InstaPay number",
                    "You'll receive our InstaPay details to transfer the payment securely.",
                  ],
                  [
                    "3",
                    "Plan activated",
                    "Once payment is confirmed, your plan goes live within 1–2 business hours.",
                  ],
                ].map(([n, title, desc]) => (
                  <div
                    key={n}
                    style={{
                      display: "flex",
                      gap: 12,
                      alignItems: "flex-start",
                    }}
                  >
                    <span
                      style={{
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        background: "#2E4053",
                        color: "#fff",
                        fontSize: 11,
                        fontWeight: 800,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        marginTop: 1,
                      }}
                    >
                      {n}
                    </span>
                    <div>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#0f172a",
                          marginBottom: 2,
                        }}
                      >
                        {title}
                      </div>
                      <div
                        style={{
                          fontSize: 12,
                          color: "#64748b",
                          lineHeight: 1.5,
                        }}
                      >
                        {desc}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <p
              style={{
                fontSize: 13,
                color: "#6b7280",
                textAlign: "center",
                lineHeight: 1.6,
              }}
            >
              Your plan will be activated within{" "}
              <strong>1–2 business days</strong> after payment confirmation.
            </p>
            <button onClick={onClose} style={M.doneBtn}>
              Close
            </button>
          </div>
        ) : (
          <>
            <div style={M.modalHeader}>
              <div>
                <div style={M.modalTier}>{plan.tier}</div>
                <div style={M.modalPlanName}>Spade {plan.name}</div>
                <div style={M.modalPrice}>
                  EGP {plan.yearlyPrice.toLocaleString()}
                  <span style={M.modalPriceSub}>
                    {" "}
                    / year &nbsp;·&nbsp; ≈ EGP {plan.monthlyEquiv} / month
                  </span>
                </div>
              </div>
              <button onClick={onClose} style={M.closeBtn} aria-label="Close">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            <div style={M.divider} />

            <p style={M.formHint}>
              Fill in your details below. After submitting, we'll send you bank
              transfer instructions and activate your plan once payment is
              confirmed.
            </p>

            <div style={M.fields}>
              <Field
                label="Full Name *"
                name="full_name"
                value={form.full_name}
                onChange={handle}
                placeholder="Ahmed Mohamed"
              />
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 14,
                }}
              >
                <Field
                  label="Email Address *"
                  name="email"
                  value={form.email}
                  onChange={handle}
                  placeholder="you@company.com"
                  type="email"
                />
                <Field
                  label="Phone Number *"
                  name="phone"
                  value={form.phone}
                  onChange={handle}
                  placeholder="+20 10 xxxx xxxx"
                  type="tel"
                />
              </div>
              <Field
                label="Company Name"
                name="company_name"
                value={form.company_name}
                onChange={handle}
                placeholder="Your company (optional)"
              />
              <Field
                label="Notes"
                name="message"
                value={form.message}
                onChange={handle}
                placeholder="Any questions or requirements?"
                textarea
              />
            </div>

            {errorMsg && <div style={M.errBox}>{errorMsg}</div>}

            <button
              onClick={submit}
              disabled={status === "loading"}
              style={{
                ...M.submitBtn,
                opacity: status === "loading" ? 0.65 : 1,
              }}
            >
              {status === "loading"
                ? "Submitting…"
                : "Submit Subscription Request"}
            </button>
            <p style={M.disclaimer}>
              No online payment required. We'll send bank transfer details by
              email.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

// ── Plan Card ─────────────────────────────────────────────────────────────────
const ACCENTS = {
  free: {
    border: "#e2e8f0",
    tierBg: "#f1f5f9",
    tierColor: "#475569",
    btnBg: "#f8fafc",
    btnColor: "#1e293b",
    btnBorder: "#cbd5e1",
    check: "#64748b",
  },
  growth: {
    border: "#2E4053",
    tierBg: "#1e3a5f",
    tierColor: "#93c5fd",
    btnBg: "#2E4053",
    btnColor: "#fff",
    btnBorder: "#2E4053",
    check: "#2E4053",
  },
  pro: {
    border: "#7C3AED",
    tierBg: "#4c1d95",
    tierColor: "#c4b5fd",
    btnBg: "#7C3AED",
    btnColor: "#fff",
    btnBorder: "#7C3AED",
    check: "#7C3AED",
  },
};

const CheckSVG = ({ color }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    style={{ flexShrink: 0, marginTop: 1 }}
  >
    <circle cx="7.5" cy="7.5" r="7.5" fill={color} fillOpacity="0.12" />
    <path
      d="M4.5 7.5l2 2.2L10.5 5"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PlanCard = ({ plan, onSelect }) => {
  const a = ACCENTS[plan.plan_key];
  return (
    <div
      style={{
        ...C.card,
        borderColor: plan.isPopular ? "#2E4053" : "#e8ecf0",
        borderWidth: plan.isPopular ? 2 : 1,
        boxShadow: plan.isPopular
          ? "0 20px 60px rgba(46,64,83,.18), 0 4px 16px rgba(46,64,83,.08)"
          : "0 2px 8px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04)",
      }}
    >
      {/* Popular ribbon */}
      {plan.isPopular && (
        <div style={C.ribbon}>
          <span style={C.ribbonText}>MOST POPULAR</span>
        </div>
      )}

      {/* Top section */}
      <div style={{ ...C.top, paddingTop: plan.isPopular ? 36 : 28 }}>
        <span
          style={{ ...C.tierBadge, background: a.tierBg, color: a.tierColor }}
        >
          {plan.tier}
        </span>
        <h2 style={C.planName}>Spade {plan.name}</h2>
        <p style={C.planDesc}>{plan.description}</p>
      </div>

      {/* Price */}
      <div style={C.priceSection}>
        {plan.isFree ? (
          <div style={C.priceRow}>
            <span style={{ ...C.bigPrice, color: "#16a34a" }}>Free</span>
            <span style={C.priceSub}>forever</span>
          </div>
        ) : (
          <>
            <div style={C.priceRow}>
              <span style={C.currency}>EGP</span>
              <span style={C.bigPrice}>
                {plan.yearlyPrice.toLocaleString()}
              </span>
              <span style={C.priceSub}>/yr</span>
            </div>
            <div style={C.priceMonthly}>
              ≈ EGP {plan.monthlyEquiv} / month · billed annually
            </div>
          </>
        )}
      </div>

      <div style={C.divider} />

      {/* Meta chips */}
      <div style={C.metaRow}>
        <span style={C.metaChip}>👥 {plan.users}</span>
        <span style={C.metaChip}>💾 {plan.storage}</span>
        <span style={C.metaChip}>🎁 {plan.trial}</span>
      </div>

      <div style={C.divider} />

      {/* Highlights */}
      <ul style={C.featureList}>
        {plan.highlights.map((h) => (
          <li key={h} style={C.featureItem}>
            <CheckSVG color={a.check} />
            <span style={{ fontSize: 13.5, color: "#374151", lineHeight: 1.5 }}>
              {h}
            </span>
          </li>
        ))}
      </ul>

      {/* CTA */}
      <button
        onClick={() => !plan.isFree && onSelect(plan)}
        style={{
          ...C.btn,
          background: a.btnBg,
          color: a.btnColor,
          border: `1.5px solid ${a.btnBorder}`,
          cursor: plan.isFree ? "default" : "pointer",
          marginTop: 20,
        }}
      >
        {plan.isFree ? "Get Started Free" : "Subscribe Now →"}
      </button>
    </div>
  );
};

// ── Comparison Table ──────────────────────────────────────────────────────────
const CmpVal = ({ v }) => {
  if (v === true)
    return (
      <span style={{ color: "#16a34a", fontWeight: 700, fontSize: 16 }}>✓</span>
    );
  if (v === false)
    return <span style={{ color: "#d1d5db", fontSize: 14 }}>—</span>;
  return (
    <span style={{ fontSize: 13, color: "#374151", fontWeight: 500 }}>{v}</span>
  );
};

const CompareTable = () => (
  <div style={{ overflowX: "auto" }}>
    <table style={T.table}>
      <thead>
        <tr>
          <th
            style={{
              ...T.th,
              textAlign: "left",
              background: "#f8fafc",
              color: "#6b7280",
              width: 200,
            }}
          >
            Feature
          </th>
          <th style={{ ...T.th, background: "#f8fafc", color: "#374151" }}>
            Starter
          </th>
          <th style={{ ...T.th, background: "#2E4053", color: "#fff" }}>
            Growth
          </th>
          <th style={{ ...T.th, background: "#7C3AED", color: "#fff" }}>Pro</th>
        </tr>
      </thead>
      <tbody>
        {COMPARE_ROWS.map((row, i) => (
          <tr
            key={row.label}
            style={{ background: i % 2 === 0 ? "#fff" : "#f8fafc" }}
          >
            <td
              style={{
                ...T.td,
                textAlign: "left",
                fontWeight: 500,
                color: "#374151",
              }}
            >
              {row.label}
            </td>
            {row.vals.map((v, j) => (
              <td
                key={j}
                style={{
                  ...T.td,
                  ...(j === 1
                    ? { background: "rgba(46,64,83,.03)" }
                    : j === 2
                    ? { background: "rgba(124,58,237,.03)" }
                    : {}),
                }}
              >
                <CmpVal v={v} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

// ── Main Page ─────────────────────────────────────────────────────────────────
// currentPageData prop accepted from SiteNavbar but not used (all data is static)
const PricingPage = ({ currentPageData }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showTable, setShowTable] = useState(false);

  return (
    <div style={P.page}>
      {/* ── Hero ── */}
      <div style={P.hero}>
        <div style={P.heroInner}>
          <div style={P.eyebrow}>
            <span style={P.eyebrowDot} />
            PRICING & PLANS
          </div>
          <h1 style={P.heroTitle}>
            Transparent Pricing.
            <br />
            <span style={{ color: "#93c5fd" }}>No Surprises.</span>
          </h1>
          <p style={P.heroSub}>
            One flat annual fee per plan. No per-user charges. No hidden costs.
            Bank transfer — your team gets access within 24 hours of payment
            confirmation.
          </p>
          <div style={P.heroBadges}>
            {[
              // "ETA e-invoicing included",
              "14-day free trial",
              "Arabic support 24/7",
              "Cancel anytime",
            ].map((t) => (
              <div key={t} style={P.heroBadge}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#93c5fd"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ flexShrink: 0 }}
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span>{t}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={P.heroDecor} />
      </div>

      {/* ── Cards ── */}
      <div style={P.cardsSection}>
        <div style={P.cardsGrid}>
          {PLANS.map((p) => (
            <PlanCard key={p.plan_key} plan={p} onSelect={setSelectedPlan} />
          ))}
        </div>
      </div>

      {/* ── Comparison table toggle ── */}
      <div style={P.section}>
        <div style={P.sectionHead}>
          <h2 style={P.sectionTitle}>Compare Plans in Detail</h2>
          <p style={P.sectionSub}>
            See a full side-by-side breakdown of every feature across all plans.
          </p>
          <button onClick={() => setShowTable((v) => !v)} style={P.toggleBtn}>
            {showTable ? "Hide comparison ▲" : "Show full comparison ▼"}
          </button>
        </div>
        {showTable && <CompareTable />}
      </div>

      {/* ── How it works ── */}
      <div style={P.howSection}>
        <div style={P.sectionHead}>
          <h2 style={P.sectionTitle}>How to Get Started</h2>
          <p style={P.sectionSub}>
            From signup to full activation in under 2 business days.
          </p>
        </div>
        <div style={P.stepsGrid}>
          {[
            {
              n: "01",
              icon: "🎯",
              title: "Choose a plan",
              desc: "Select the plan that fits your team size and business needs.",
            },
            {
              n: "02",
              icon: "📋",
              title: "Submit your details",
              desc: "Fill in your name, company, and contact info. Takes 60 seconds.",
            },
            {
              n: "03",
              icon: "🏦",
              title: "Bank transfer",
              desc: "We'll email you our bank account details. Transfer the annual fee.",
            },
            {
              n: "04",
              icon: "🚀",
              title: "Instant activation",
              desc: "Once we confirm your payment, your plan is live within 1–2 business days.",
            },
          ].map((s, i) => (
            <div key={s.n} style={P.stepCard}>
              <div style={P.stepTop}>
                <span style={P.stepNum}>{s.n}</span>
                <span style={P.stepIcon}>{s.icon}</span>
              </div>
              <h3 style={P.stepTitle}>{s.title}</h3>
              <p style={P.stepDesc}>{s.desc}</p>
              {i < 3 && <div style={P.stepArrow}>→</div>}
            </div>
          ))}
        </div>
      </div>

      {/* ── Trust bar ── */}
      <div style={P.trustBar}>
        {[
          ["🔒", "Secure payments", "Bank-grade security"],
          ["🇪🇬", "ETA compliant", "Phase 1 & 2 certified"],
          ["📞", "Arabic support", "Dedicated team"],
          ["💸", "Money-back guarantee", "14 days, no questions"],
          ["⚡", "Fast onboarding", "Live in 48 hours"],
        ].map(([icon, title, sub]) => (
          <div key={title} style={P.trustItem}>
            <span style={P.trustIcon}>{icon}</span>
            <div>
              <div style={P.trustTitle}>{title}</div>
              <div style={P.trustSub}>{sub}</div>
            </div>
          </div>
        ))}
      </div>

      {selectedPlan && (
        <SubscribeModal
          plan={selectedPlan}
          onClose={() => setSelectedPlan(null)}
        />
      )}
    </div>
  );
};

export default PricingPage;

// ── Page Styles ───────────────────────────────────────────────────────────────
const P = {
  page: {
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    fontFamily:
      "'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
  },

  // hero
  hero: {
    background: "linear-gradient(135deg,#0f172a 0%,#1e3a5f 60%,#1e1b4b 100%)",
    position: "relative",
    overflow: "hidden",
    padding: "72px 24px 80px",
  },
  heroInner: {
    maxWidth: 760,
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    textAlign: "center",
  },
  heroDecor: {
    position: "absolute",
    top: -120,
    right: -120,
    width: 480,
    height: 480,
    borderRadius: "50%",
    background:
      "radial-gradient(circle,rgba(124,58,237,.18) 0%,transparent 70%)",
    pointerEvents: "none",
  },
  eyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 3,
    color: "#93c5fd",
    marginBottom: 20,
    textTransform: "uppercase",
  },
  eyebrowDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#60a5fa",
    display: "inline-block",
  },
  heroTitle: {
    fontSize: "clamp(32px,5vw,52px)",
    fontWeight: 800,
    color: "#f1f5f9",
    lineHeight: 1.12,
    margin: "0 0 20px",
    letterSpacing: -1,
  },
  heroSub: {
    fontSize: 17,
    color: "#94a3b8",
    lineHeight: 1.75,
    maxWidth: 600,
    margin: "0 auto 32px",
  },
  heroBadges: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "10px 20px",
  },
  heroBadge: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    fontSize: 13.5,
    color: "#cbd5e1",
    fontWeight: 500,
  },

  // cards
  cardsSection: { padding: "64px 24px 48px", background: "#f8fafc" },
  cardsGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 28,
    maxWidth: 1160,
    margin: "0 auto",
  },

  // sections
  section: { maxWidth: 1000, margin: "0 auto", padding: "48px 24px" },
  sectionHead: { textAlign: "center", marginBottom: 36 },
  sectionTitle: {
    fontSize: 28,
    fontWeight: 800,
    color: "#0f172a",
    margin: "0 0 10px",
    letterSpacing: -0.5,
  },
  sectionSub: {
    fontSize: 15,
    color: "#64748b",
    margin: "0 0 20px",
    lineHeight: 1.6,
  },
  toggleBtn: {
    background: "none",
    border: "1.5px solid #e2e8f0",
    borderRadius: 8,
    padding: "9px 22px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    color: "#374151",
  },

  // how it works
  howSection: {
    background: "#fff",
    padding: "64px 24px",
    borderTop: "1px solid #e2e8f0",
    borderBottom: "1px solid #e2e8f0",
  },
  stepsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
    gap: 2,
    maxWidth: 1100,
    margin: "0 auto",
    position: "relative",
  },
  stepCard: {
    background: "#f8fafc",
    borderRadius: 14,
    padding: "28px 24px 24px",
    position: "relative",
    border: "1px solid #e8ecf0",
  },
  stepTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 14,
  },
  stepNum: {
    fontSize: 11,
    fontWeight: 800,
    color: "#2E4053",
    letterSpacing: 2,
    background: "#e0e7ff",
    padding: "4px 10px",
    borderRadius: 6,
  },
  stepIcon: { fontSize: 26 },
  stepTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: "#0f172a",
    margin: "0 0 8px",
  },
  stepDesc: { fontSize: 13.5, color: "#64748b", lineHeight: 1.6, margin: 0 },
  stepArrow: {
    position: "absolute",
    right: -14,
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: 20,
    color: "#cbd5e1",
    zIndex: 2,
    display: "none",
  },

  // trust bar
  trustBar: {
    background: "#0f172a",
    padding: "32px 24px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "24px 48px",
  },
  trustItem: { display: "flex", alignItems: "center", gap: 12 },
  trustIcon: { fontSize: 24 },
  trustTitle: { fontSize: 13, fontWeight: 700, color: "#f1f5f9" },
  trustSub: { fontSize: 12, color: "#64748b", marginTop: 1 },
};

// ── Card Styles ───────────────────────────────────────────────────────────────
const C = {
  card: {
    width: 340,
    background: "#fff",
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    borderStyle: "solid",
    transition: "transform .2s",
  },
  ribbon: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    background: "linear-gradient(90deg,#2E4053,#1e3a5f)",
    padding: "7px 0",
    textAlign: "center",
  },
  ribbonText: {
    fontSize: 10,
    fontWeight: 800,
    color: "#93c5fd",
    letterSpacing: 3,
  },
  top: { padding: "0 28px 20px" },
  tierBadge: {
    display: "inline-block",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 2,
    padding: "4px 12px",
    borderRadius: 20,
    marginBottom: 14,
  },
  planName: {
    fontSize: 24,
    fontWeight: 800,
    color: "#0f172a",
    margin: "0 0 8px",
    letterSpacing: -0.5,
  },
  planDesc: { fontSize: 13.5, color: "#64748b", lineHeight: 1.6, margin: 0 },
  priceSection: {
    padding: "20px 28px",
    background: "#f8fafc",
    borderTop: "1px solid #f1f5f9",
    borderBottom: "1px solid #f1f5f9",
  },
  priceRow: {
    display: "flex",
    alignItems: "flex-end",
    gap: 4,
    marginBottom: 4,
  },
  currency: {
    fontSize: 17,
    fontWeight: 700,
    color: "#374151",
    lineHeight: 2.6,
  },
  bigPrice: {
    fontSize: 48,
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1,
    letterSpacing: -2,
  },
  priceSub: { fontSize: 14, color: "#94a3b8", lineHeight: 2.6, marginLeft: 4 },
  priceMonthly: { fontSize: 12, color: "#94a3b8" },
  divider: { height: 1, background: "#f1f5f9", margin: "0 28px" },
  metaRow: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    padding: "18px 28px",
  },
  metaChip: {
    fontSize: 13,
    color: "#374151",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  featureList: {
    listStyle: "none",
    padding: "4px 28px 0",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: 9,
  },
  featureItem: { display: "flex", alignItems: "flex-start", gap: 9 },
  btn: {
    margin: "0 28px 28px",
    padding: "14px",
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 700,
    textAlign: "center",
    transition: "opacity .15s, transform .1s",
  },
};

// ── Table Styles ──────────────────────────────────────────────────────────────
const T = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 13.5,
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,.08)",
    minWidth: 640,
  },
  th: {
    padding: "14px 18px",
    textAlign: "center",
    fontWeight: 700,
    fontSize: 13,
    border: "1px solid #e8ecf0",
  },
  td: {
    padding: "12px 18px",
    textAlign: "center",
    border: "1px solid #f1f5f9",
  },
};

// ── Modal Styles ──────────────────────────────────────────────────────────────
const M = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15,23,42,.6)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: 16,
  },
  modal: {
    background: "#fff",
    borderRadius: 20,
    width: "100%",
    maxWidth: 520,
    maxHeight: "92vh",
    overflowY: "auto",
    padding: "32px 32px 28px",
    boxShadow: "0 24px 64px rgba(0,0,0,.2)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 20,
  },
  modalTier: {
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 3,
    color: "#2E4053",
    marginBottom: 4,
  },
  modalPlanName: {
    fontSize: 24,
    fontWeight: 800,
    color: "#0f172a",
    letterSpacing: -0.5,
    marginBottom: 6,
  },
  modalPrice: { fontSize: 20, fontWeight: 800, color: "#0f172a" },
  modalPriceSub: { fontSize: 13, fontWeight: 400, color: "#94a3b8" },
  closeBtn: {
    background: "none",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    width: 36,
    height: 36,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#64748b",
    flexShrink: 0,
  },
  divider: { height: 1, background: "#f1f5f9", margin: "20px 0" },
  formHint: {
    fontSize: 13.5,
    color: "#64748b",
    lineHeight: 1.65,
    margin: "0 0 22px",
    padding: "12px 16px",
    background: "#f8fafc",
    borderRadius: 10,
    border: "1px solid #e2e8f0",
  },
  fields: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    marginBottom: 20,
  },
  input: {
    padding: "11px 14px",
    border: "1.5px solid #e2e8f0",
    borderRadius: 9,
    fontSize: 14,
    color: "#0f172a",
    outline: "none",
    fontFamily: "inherit",
    width: "100%",
    boxSizing: "border-box",
    background: "#fff",
  },
  errBox: {
    background: "#fef2f2",
    border: "1px solid #fecaca",
    borderRadius: 8,
    padding: "10px 14px",
    fontSize: 13,
    color: "#dc2626",
    marginBottom: 14,
  },
  submitBtn: {
    width: "100%",
    padding: "14px",
    background: "#2E4053",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
    letterSpacing: 0.2,
  },
  disclaimer: {
    fontSize: 12,
    color: "#94a3b8",
    textAlign: "center",
    marginTop: 12,
    lineHeight: 1.6,
  },
  successWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: 14,
    padding: "8px 0",
  },
  successIconWrap: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    background: "#f0fdf4",
    border: "2px solid #86efac",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  successTitle: {
    fontSize: 24,
    fontWeight: 800,
    color: "#0f172a",
    margin: 0,
    letterSpacing: -0.5,
  },
  successText: {
    fontSize: 14,
    color: "#374151",
    lineHeight: 1.65,
    margin: 0,
    maxWidth: 380,
  },
  payBox: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    padding: "18px 20px",
    width: "100%",
    textAlign: "left",
  },
  payTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: 12,
  },
  payGrid: {
    display: "grid",
    gridTemplateColumns: "130px 1fr",
    gap: "8px 12px",
    fontSize: 13,
  },
  payKey: { color: "#64748b" },
  payVal: { color: "#0f172a", fontWeight: 600 },
  payNote: {
    marginTop: 14,
    fontSize: 12,
    color: "#92400e",
    background: "#fef3c7",
    padding: "9px 12px",
    borderRadius: 7,
    lineHeight: 1.55,
  },
  doneBtn: {
    background: "#2E4053",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: "13px 36px",
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
  },
};
